export enum ColorModes {
  success = 'SUCCESS',
  warning = 'WARNING',
  error = 'ERROR',
  blue = 'BLUE',
  gray = 'GRAY',
  yellow = 'YELLOW',
  orange = 'ORANGE',
  pinkGraph = 'PINK_GRAPH',
  violet = 'VIOLET',
}
